const toolbox = `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
<block type="moveforward"></block>
<block type="turnleft">
  <field name="NAME">turnLeft</field>
</block>
<block type="turnright">
  <field name="NAME">turnRight</field>
</block>
<block type="if_block">
  <field name="NAME">If</field>
  <field name="OPTION">OPTIONNAME</field>
</block>
<block type="if_else">
  <field name="NAME">If</field>
  <field name="DROPDOWN">TORIGHT</field>
</block>
<block type="for_block">
  <field name="NAME">Repeat for</field>
  <field name="Input">0</field>
  <field name="NAME2">times</field>
</block>
<block type="while">
  <field name="NAME">While Destination Not Reached</field>
</block>
</xml>`;

export default toolbox;
